function PinCode({
  loading,
  pincode,
  setPincode,
  isPincodeLocked,
  handleCheck,
  handleReset,
  pinloading,
  pinerror,
  pincodeDetails,
  Skeleton,
  LocationTick,

}){
  return(

 <div className={`pincode-check ${loading ? "no-border" : ""}`} style={{ margin:"10px 0"}}>
      {loading ? (
        <>
          <Skeleton height={18} width={160} style={{ marginBottom: 10 }} />
        </>
      ) : (
        <>
          <p className="check-heading">CHECK AVAILABILITY</p>
          <div className="input-wrapper-quick-2">
            <input
className="checkup_track_txt"
type="text"
placeholder="Enter Delivery Pincode"
value={pincode}
maxLength={6}
disabled={isPincodeLocked}
onChange={(e) => {
if (isPincodeLocked) return;
const onlyNums = e.target.value.replace(/\D/g, "");
setPincode(onlyNums);
}}
onKeyDown={(e) => {
if (isPincodeLocked) return;
if (e.key === "Enter" && pincode.length === 6) {
handleCheck();
}
}}
/>

<div className="btn-group">
{/* Show CHECK only if not verified */}
{!isPincodeLocked && (
<button
onClick={handleCheck}
className="check-btn-2"
disabled={pinloading || pincode.length !== 6}
>
{pinloading ? "Checking..." : "Check"}
</button>
)}

{/* Show RESET only if verified */}
{isPincodeLocked && (
<button onClick={handleReset} className="rest-btn">
Reset
</button>
)}
</div>
</div>
          {pinloading && <p>Checking...</p>}
          {pinerror && (
            <p style={{ color: "red", marginTop: "15px" }}>
              Not serviceable for your area
            </p>
          )}
          {pincodeDetails?.pincode && pincodeDetails?.is_active && (
            <p style={{ color: "green", marginTop: "15px" }}>
              <span style={{ position: 'relative', bottom: '4px' }}>   <LocationTick
                size="24"
                color="green"
                variant="Bold"
              /></span> Delivery available at {pincodeDetails?.city}, {pincodeDetails?.state} (
              {pincodeDetails?.delivery_tat})
            </p>
          )}
        </>
      )}
    </div>

  )

}
export default PinCode;